import React from 'react';
import { useState, useEffect, Fragment } from "react";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';

const EditRolesAndRights = ({ show, handleClose, mode = 'role', data = {}, onSave, disableRightType = false }) => {
    const title = mode === 'rights' ? 'Edit Right' : 'Edit Role Creation';
    const [formData, setFormData] = useState({
        RoleName: '',
        RoleDescription: '',
        RightId: '',
        RightType: '',
        DisplayName: '',
        RightDescription: '',
    });

    useEffect(() => {
        if (show && data) {
            setFormData({
                RoleName: data.RoleName || '',
                RoleDescription: data.RoleDescription || '',
                RightId: data.RightId || '',
                RightType: data.RightType || '',
                DisplayName: data.DisplayName || '',
                RightDescription: data.RightDescription || '',
            });
        }
    }, [show, data]);
    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Form>
                <Modal.Body>
                    <Row>
                        {mode === 'rights' ? (
                            <>
                                <Col sm={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Right ID</Form.Label>
                                        <Form.Control
                                            type="text"
                                            size='sm'
                                            placeholder="Enter Right ID"
                                            value={formData.RightId}
                                            disabled={disableRightType}
                                            onChange={(e) => setFormData({ ...formData, RightId: e.target.value })} />
                                    </Form.Group>
                                </Col>
                                <Col sm={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Right Type</Form.Label>
                                        <Form.Control type="text" size='sm' placeholder="Enter Right Type"
                                            value={formData.RightType}
                                            disabled={disableRightType}
                                            onChange={(e) => setFormData({ ...formData, RightType: e.target.value })} />
                                    </Form.Group>
                                </Col>
                                <Col sm={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Display Name</Form.Label>
                                        <Form.Control type="text" size='sm' placeholder="Enter Display Name"
                                            value={formData.DisplayName}
                                            onChange={(e) => setFormData({ ...formData, DisplayName: e.target.value })} />
                                    </Form.Group>
                                </Col>
                                <Col sm={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Description</Form.Label>
                                        <Form.Control type="text" size='sm' placeholder="Enter Description"
                                            value={formData.RightDescription}
                                            onChange={(e) => setFormData({ ...formData, RightDescription: e.target.value })} />
                                    </Form.Group>
                                </Col>
                            </>
                        ) : (
                            <><Col sm={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Role Name</Form.Label>
                                    <Form.Control
                                        type="text"
                                        size='sm'
                                        placeholder="Enter Role Name"
                                        value={formData.RoleName}
                                        onChange={(e) => setFormData({ ...formData, RoleName: e.target.value })}                                  
                                    />                               
                                </Form.Group>
                            </Col><Col sm={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Role Description</Form.Label>
                                        <Form.Control
                                            type="text"
                                            size='sm'
                                            placeholder="Enter Role Description"
                                            value={formData.RoleDescription}
                                            onChange={(e) => setFormData({ ...formData, RoleDescription: e.target.value })}
                                        />
                                    </Form.Group>
                                </Col></>
                        )}
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" size='sm' onClick={handleClose}>
                        Cancel
                    </Button>
                    <Button variant="primary" size='sm' onClick={() => {
                        if (onSave) onSave(formData);
                        handleClose();
                    }}>
                        Save
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
};

export default EditRolesAndRights;